import { fmap } from "./fmap";

export function parseUrl(urlString: string) {
  try {
    const url = new URL(urlString);

    const pathParams = url.pathname.split("/").slice(1);
    const pageName = pathParams.at(0);
    const passedProps = safeJsonParse(
      fmap(url.searchParams.get("props"), decodeURIComponent) ?? "{}"
    );

    return {
      pageName: pageName === "" ? undefined : pageName,
      passedProps: passedProps,
    };
  } catch (e) {
    console.error("failed to parse url", urlString, e);
    return {
      pageName: undefined,
      passedProps: {},
    };
  }
}

function safeJsonParse(json: string) {
  try {
    return JSON.parse(json);
  } catch (e) {
    console.error("failed to parse json", json, e);
    return {};
  }
}
